import React, { memo, useCallback, useState } from 'react';
import {
    MonthNumber,
    PayStateT,
} from 'routes/HumanResourcesModule/PayState/helpers/types';
import { useGetSupCompHoursData } from '../helpers/hooks/payStateData';
import ShowLastYearToggle from '../components/ShowLastYearToggle';
import { getCurrentMonthForExercice } from '../../helpers/dataHelpers';
import MonthSelector from '../components/MonthSelector';
import SupCompAmountsGrid from './components/SupCompAmountsGrid';

type Props = {
    payState: PayStateT;
};

const SupCompAmounts = ({ payState }: Props): React.ReactElement => {
    const { id: payStateId, exercice } = payState;

    const [selectedMonth, setSelectedMonth] = useState<MonthNumber>(() =>
        getCurrentMonthForExercice(payState.exercice),
    );

    const [showLastYearColumns, setShowLastYearColumns] = useState(false);

    const { data: hsHcAmountsResponse, isLoading: isDataGridResponseLoading } =
        useGetSupCompHoursData(payStateId, selectedMonth);

    const hsHcAmounts = hsHcAmountsResponse?.data || [];

    const toggleLastYearColumns = useCallback(
        () => setShowLastYearColumns((current) => !current),
        [],
    );
    const cardHeaderActions = (
        <>
            <ShowLastYearToggle
                checked={showLastYearColumns}
                onChange={toggleLastYearColumns}
                lastYear={exercice - 1}
            />
            <MonthSelector
                allYearOption
                exercice={payState.exercice}
                selectedMonth={selectedMonth}
                setSelectedMonth={setSelectedMonth}
            />
        </>
    );

    return (
        <SupCompAmountsGrid
            payState={payState}
            hsHcAmounts={hsHcAmounts}
            isLoading={isDataGridResponseLoading}
            cardHeaderActions={cardHeaderActions}
            month={selectedMonth}
            showLastYearColumns={showLastYearColumns}
        />
    );
};

export default memo(SupCompAmounts);
